/*eslint-disable */
<template>
  <div class="questionContainer full-width-page iq-card pl-3" v-if="questionList.length" :key="refreshComponent">
    <!--columns-->
    <div style="width: 100%;" class="row header-title questionRow m-0 p-0">
      <div class="row quiz-top-header m-0">
        <div class="col-5 col-md-4 d-flex align-items-center header-title-col">
          <span class="heading" v-if="propModalTitle">{{ propModalTitle }}</span>
          <div v-else class="sidebarContainer que m-2">
            <div class="tags is-marginless">
              <h3 class="tag is-rounded mb-2" v-if="examDetail.has_timer">
                <span> {{ examDetail && (examDetail.app_name_alias || examDetail.app_name) }} </span>
                <div class="duration">
                  <div class="counts" v-if="examDetail && examDetail.app_name && examDetail.app_type == 'testseries' && (examDetail.app_name.includes('CW') || examDetail.app_name.includes('CLASSWORK')) ">
                    <b-button variant="primary" class="btn mr-3" @click="goToTestSeriesAnalysisPage()" :disabled="questionIndex < 1">
                      Quit & Analyze
                    </b-button>
                  </div>
                </div>
              </h3>
            </div>
          </div>
        </div>
        <div class="col-4 timer_drop">
          <div id="timer" v-if="examDetail.app_duration > 0 && examDetail.has_timer" :key="timer.sec">
            <span class="clock_boxs"><span class="clock_box1">{{timer.min}}&nbsp;Min&nbsp;</span>
              <span class="colon">:</span>
              <span class="clock_box2">{{timer.sec}}&nbsp;Sec&nbsp;</span>
            </span>
          </div>
        </div>
        <!-- Header Tools: Calculator & Report Issue (image zoom lives inside each image box) -->
        <div class="col-3 col-md-4 d-flex align-items-center justify-content-end header-tools">
          <button class="btn header-tool-btn" v-if="questionList[questionIndex].has_calc === 1" @click="showCalculatorModal = !showCalculatorModal" title="Desmos Calculator">
            <i class="fa-solid fa-calculator font-size-20" aria-hidden="true"></i>
            <span class="d-none d-md-inline">Calculator</span>
          </button>
          <button class="btn header-tool-btn" @click="showModelReportFn(questionList[questionIndex].qbk_id, 'quizBank_edit')" title="Report issue for this question">
            <i class="fa-solid fa-triangle-exclamation font-size-20" aria-hidden="true"></i>
            <span class="d-none d-md-inline">Report</span>
          </button>
        </div><!-- Header Tools -->
      </div>
      <!--questionBox-->
      <div class="row questionBox">
        <div class='col-12 stacked-wrapper'>
          <!--row-->
          <div class="stacked-view px-2 px-sm-3">
            <!-- Question Header Bar -->
            <div class="question-header-bar">
              <div class="d-flex align-items-center">
                <span class="question-number">{{ parseInt(questionIndex) + 1 }}</span>
                <span class="cursor-pointer mark-review" v-if="!toBeReviewedQuestionIndexList.includes(parseInt(questionIndex))" @click="markUnmarkQuestionForReview()">
                  <i class="fa-regular fa-bookmark" style="color: orange"></i>&nbsp;Mark for Review
                </span>
                <span class="cursor-pointer mark-review" @click="markUnmarkQuestionForReview()" v-else>
                  <i class="fa-solid fa-bookmark" style="color: orange"></i>&nbsp;Marked for Review
                </span>
              </div>
            </div>
            <!-- Question Header Bar -->

            <!--qusetion Container-->
            <div class="stacked-question">
              <h2 class="title is-2 questionTag vhtmlUlLi w-100" v-html="withImageZoomButtons(questionList[questionIndex].question)" @click="onQuestionContentClick"></h2>

              <!-- images -->
              <div class="q-img-box" v-if="questionList[questionIndex].image">
                <div class="q-img-toolbar">
                  <button type="button" class="q-img-zoom-btn" @click="imgModal(questionList[questionIndex].image)" title="Zoom Image" aria-label="Zoom Image">
                    <i class="fa fa-search-plus" aria-hidden="true"></i>
                  </button>
                </div>
                <img class="que_img" :src="questionList[questionIndex].image"/>
              </div>
              <!-- images -->
            </div>
            <!--qusetion Container-->

            <!--Answer/Options Container-->
            <div v-if="questionIndex < questionList.length" class="questionContainer stacked-options" v-bind:key="questionIndex">
              <!-- Options -->
              <div class="optionContainer" :key="update">
                <template v-if="questionList[questionIndex].is_mcq == 1">
                  <div class="option" v-for="(choice, optionNo) in questionList[questionIndex].answer_choices" @click="selectOption(optionNo)" :class="{'is-selected': userResponses[questionList[questionIndex].qbk_id] && userResponses[questionList[questionIndex].qbk_id][optionNo], }" :key="optionNo">
                    <span class="optionNo capitalize">{{ optionNo }}</span>
                    <span class="vhtmlUlLi optionText" v-html="choice"></span>
                  </div>
                </template>
                <template v-else>
                  <div class="non-mcq-container">
                    <b-form-textarea
                      v-if="questionList[questionIndex].qbk_id in userResponses"
                      placeholder="Write Your answer here"
                      class="rounded form-control mb-2"
                      rows="4"
                      max-rows="10"
                      v-model="userResponses[questionList[questionIndex].qbk_id].answer"
                      style="line-height: 1.3; z-index: 9; border-color: #e5252c; height: 400px;"
                      @keypress="validateNumericInput($event, questionIndex)"
                    />
                    <b-button
                      variant="primary"
                      size="sm"
                      class="mt-2 expandButton"
                      @click="showAnswerModal = true"
                    >
                      <i class="fa fa-expand mr-0"></i>
                    </b-button>
                  </div>
                </template>

                <!-- User's Answer Screenshot Upload -->
                <div v-if="questionList[questionIndex].is_allowed_to_img_upload === 1" class="form-group row align-items-center py-4">
                  <!-- Upload Documents -->
                  <div class="row col-12 w-100 mt-2">
                    <div class="col-md-12">
                      <label for="validationblog_attach">{{cvAnswerImgAttachmentLabel}}</label>&nbsp;&nbsp;
                      <label for="ansImgAttachmentFileInput" class="pointer primary-color" @mousedown="ALLOWWINDOWOPEN = true">(Click here to upload)&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa-solid fa-upload"></i></label>
                      <input type="file" :accept="allowedExtensions" class="dontShow" id="ansImgAttachmentFileInput" @click="ALLOWWINDOWOPEN = true" @change="onAnsImgAttatachmentChange($event, userResponses[questionList[questionIndex].qbk_id], 'ansImgAttachmentFileInput')">
                    </div>
                    <div class="col-md-12">
                      <template v-if="userResponses[questionList[questionIndex].qbk_id]?.answer_image || answer_image_preview">
                          <!-- Uploaded S3 URL -->
                          <div v-if="typeof userResponses[questionList[questionIndex].qbk_id]?.answer_image === 'string' && userResponses[questionList[questionIndex].qbk_id].answer_image" class="attachmentCol mr-4">
                            <img :src="pdfLogo" @click="openFile(userResponses[questionList[questionIndex].qbk_id].answer_image)">
                            <span class="pointer" @click="openFile(userResponses[questionList[questionIndex].qbk_id].answer_image)">{{ userResponses[questionList[questionIndex].qbk_id].answer_image.split("/").pop() ?? "Uploaded file"}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                            <span class="addIcon extraCloseIcon" @click="removeImage(`ansImgAttachmentFileInput`)"><i class="fa-solid fa-circle-xmark pointer"></i></span>
                          </div>

                          <!-- Staged preview (before upload) -->
                          <div v-else-if="answer_image_preview && answer_image_name" class="attachmentCol mr-4">
                            <img :src="pdfLogo" @click="openFile(answer_image_preview)">
                            <span class="pointer" @click="openFile(answer_image_preview)">{{ answer_image_name }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                            <span class="addIcon extraCloseIcon" @click="removeImage(`ansImgAttachmentFileInput`)"><i class="fa-solid fa-circle-xmark pointer"></i></span>
                          </div>
                      </template>
                    </div>
                  </div><!-- Upload Documents -->
                </div>
                <!-- User's Answer Screenshot Upload -->
              </div>
              <!-- Options -->
            </div>
            <!--Answer/Options Container-->
          </div>
          <!--row-->

          <!--/quizCompetedResult-->
          <div v-if="questionIndex >= questionList.length && quizStarted" v-bind:key="questionIndex" class="quizCompleted has-text-centered">
            <!-- quizCompletedIcon: Achievement Icon -->
            <span class="icon is-large has-text-success">
              <i class="fa fa-check-circle-o fa-3x"></i>
            </span>

            <!--resultTitleBlock-->
            <h2 class="title">You did an amazing job!</h2>
            <p class="subtitle">
              Total score: {{ score() }} / {{ questionList.length }}
            </p>
            <!--/resultTitleBlock-->
          </div>
          <!--/quizCompetedResult-->
        </div>
          <chatbot
            v-if="examDetail.is_ai_tutor == 1"
            :propQuestion="questionList[questionIndex].question"
            :propIsMcq="questionList[questionIndex].is_mcq === 1 ? true : false"
            :propAnswerChoices="questionList[questionIndex].answer_choices"
            :propQbkId="questionList[questionIndex].qbk_id"
            propModuleName="QUIZBOT"
            @emit-chatbotclose="chatBotclose()"
          />
      </div>
      <!--/questionBox-->

      <!--quizFooter: navigation and progress-->
      <div class="questionFooter col-12 mt-2">
        <div class="footer-nav-row">
          <div>
            <!-- prevButton -->
            <b-button v-if="questionIndex > 0" variant="primary" class="btn" @click="prev()">
              Previous
            </b-button><!-- prevButton -->
          </div>

          <div class="text-right">
            <!-- nextButton -->
            <b-button variant="primary" class="btn btn-primary" @click="next()" :disabled="questionIndex >= questionList.length || !userResponses[questionList[questionIndex].qbk_id]">
              {{questionList.length != questionIndex+1 ? 'Next' : 'Submit'}}
            </b-button><!-- nextButton -->
          </div>
        </div>

        <!--progress-->
        <div class="progressContainer mt-4">
          <progress
            class="progress is-success is-small w-100 mb-1"
            :value="(questionIndex / questionList.length) * 100"
            max="100"
          >
            {{ (Object.keys(userResponses).length / questionList.length) * 100 }}%
          </progress>
        </div><!--progress-->
        <div class="footer-status-row">
          <div class="attempted_total"><span>Attempted: {{ getAttemptedQuestions(userResponses) }}</span>&nbsp;&nbsp;| &nbsp;&nbsp; <span>Skipped: {{ getSkippedQuestions(userResponses) }}</span></div>

          <!-- Question Navigator -->
          <div class="question-nav-anchor">
            <b-button
              variant="primary"
              class="btn question-nav-badge"
              :class="{ 'is-clickable': examDetail.is_question_shortcut }"
              :aria-expanded="showQuestionNav ? 'true' : 'false'"
              @click="toggleQuestionNav"
            >
              Question {{ parseInt(questionIndex) + 1 }} of {{ questionList.length }}
              <i v-if="examDetail.is_question_shortcut" class="fa-solid ml-1" :class="showQuestionNav ? 'fa-chevron-down' : 'fa-chevron-up'" aria-hidden="true"></i>
            </b-button>

            <div v-if="showQuestionNav" class="question-nav-backdrop" @click="showQuestionNav = false"></div>
            <div v-if="showQuestionNav" class="question-nav-popup">
              <div class="question-nav-grid">
                <button
                  type="button"
                  v-for="(q, index) in questionList.length"
                  :key="index"
                  class="question-nav-item"
                  :class="getQuestionNavClass(index)"
                  @click="goToQuestionFromNav(index)"
                >
                  {{ index + 1 }}
                  <i v-if="toBeReviewedQuestionIndexList.includes(index)" class="fa-solid fa-bookmark nav-marked" aria-hidden="true"></i>
                </button>
              </div>
              <div class="question-nav-legend">
                <span><span class="legend-box is-current"></span>Current</span>
                <span><span class="legend-box is-answered"></span>Answered</span>
                <span><span class="legend-box is-skipped"></span>Skipped</span>
                <span><i class="fa-solid fa-bookmark" style="color: orange"></i>&nbsp;Marked</span>
              </div>
            </div>
          </div>
          <!-- Question Navigator -->

          <div class="attempted_total text-right"><span>Total Questions: {{questionList.length}}</span></div>
        </div>
      </div><!--quizFooter: navigation and progress-->
    </div><!--/columns-->

    <!-- Quiz Instructions -->
    <b-modal
      title="Instructions"
      v-model="showQuizInstructionsModal"
      scrollable
      no-close-on-backdrop
      hide-footer
      id="xxl"
      class="modal_middle"
      @close="handleQuizInstructionModalClose"
      >
        <hr>
        <QuestionQuizInstruction v-if="examDetail" :propAppDetails="examDetail"/>
        <div class="row">
          <div class="col-6">
            <b-button variant="primary" @click="handleQuizInstructionModalClose" class="btn pull-right font-weight-bold">
              Start
            </b-button>
          </div>
        </div>
    </b-modal><!-- Quiz Instructions -->

    <!-- Quiz analysis and Question number grid (QuizAnalysisAndQuestionNumberGrid) -->
    <b-modal
      v-model="showSubmitModal"
      scrollable
      no-close-on-backdrop
      hide-footer
      id="md"
      class="modal_middle"
      @close="handleQuizAnalysisAndQuestionNumberGridModal"
      >
        <h5 style="font-weight:500; text-align: center;">Are you ready to submit? Please note, once you submit you won't be able to retake it.</h5>
        <!-- Question wise grid -->
        <div class="row pt-3">
          <!-- Pills for question status -->
           <div class="col-12">
              <span v-for="(qbkId, index) in Object.keys(userResponses)" :key="qbkId">
                <b-badge
                  pill
                  class="m-1 font-size-14 pill_badge_box pointer"
                  @click="closeSubmitModalAndGoToQuestion(index)"
                  :style="{ backgroundColor: getOptionColor(qbkId), color: '#fff' }"
                >
                  {{ String(index + 1).padStart(2, '0') }}
                   <i v-if="toBeReviewedQuestionIndexList.includes(index)" class="fa-solid fa-bookmark" style="color:orange;"></i>
                </b-badge>
              </span>
            </div>
        </div><!-- Question wise grid -->

        <div class="mt-5 row pt-3">
          <!-- Pills for question status -->
          <div class="col-12 final_result">
            <!-- <p class="mb-0"><span>Total Questions:&nbsp;</span>{{ Object.keys(userResponses).length }}</p> -->
            <span class="mb-0 ml-4">
              <b-badge
                pill
                class="m-1 font-size-12 pill_badge_box_small pointer"
                :style="{ backgroundColor: '#3366CC !important', color: '#fff' }"
              >
                {{ gridAnsweredQuestions }}
              </b-badge>
              <span>Answered&nbsp;</span>
            </span>
            <span class="mb-0 ml-4">
              <b-badge
                pill
                class="m-1 font-size-12 pill_badge_box_small pointer"
                :style="{ backgroundColor: '#888 !important', color: '#fff' }"
              >
                {{ gridUnansweredQuestions }}
              </b-badge>
              <span>Unanswered</span>
            </span>
            <span class="mb-0 ml-4">
              <b-badge
                pill
                class="m-1 font-size-12 pill_badge_box_small pointer"
                :style="{ backgroundColor: '#eee !important', color: '#fff' }"
              >
                <i class="fa-solid fa-bookmark" style="color:orange"></i>
              </b-badge>
              <span>Marked</span>
            </span>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-6">
            <b-button variant="warning" class="btn text-white font-weight-bold" @click="handleQuizSubmission(false)">
              Review
            </b-button>
          </div>
          <div class="col-6">
            <b-button variant="primary" class="btn pull-right font-weight-bold" @click="handleQuizSubmission(true)">
              Submit
            </b-button>
          </div>
        </div>
    </b-modal><!-- Quiz analysis and Question number grid -->

    <b-modal id="DemosCal" v-model="showCalculatorModal" @shown="makeDraggable" size="lg">
      <template #modal-header="">
        <h4 class=" mb-1 instituteTitle_block">
          Desmos Calculator <i class="fa-solid fa-arrows-up-down-left-right pointer pull-right m-2" title="Drag calculator"  aria-hidden="true"></i>
        </h4>
      </template>
      <iframe style="height: 70vh; width: 100%;" :src="desmosCalc" />
    </b-modal>

    <!-- Show Large Image -->
    <b-modal
      v-model="showModelImageView"
      name="Modal"
      scrollable
      size="xl"
      >
      <image-view :propImageUrl="propImageUrl"/>
    </b-modal><!-- Show Large Image -->

    <b-modal
      v-model="showSubmitLoader"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      centered
      content-class="bg-transparent border-0"
    >
      <div class="d-flex flex-column align-items-center text-white">
        <div class="spinner-border" role="status" style="width: 3rem; height: 3rem;">
          <span class="sr-only">Submitting...</span>
        </div>
        <p class="mt-3 font-weight-bold font-size-18">DO NOT CLOSE or REFRESH this SCREEN</p>
        <p class="mt-3 font-weight-bold font-size-18">Your assessment submission is in progress</p>
      </div>
    </b-modal>

    <b-modal name="Modal" v-model="showReportIssueModalBox" scrollable size="md" title="Report Issue" centered modal-class="custom-modal-bg"  hide-footer  no-close-on-backdrop no-close-on-esc>
      <ReportIssue v-if="showReportIssueModalBox" @emitCloseadminReportIssueAddModal="closeReportAddModal" :propModuleId="reportModuleObjId" propModuleType="quizBank_edit" :propModalQuestion="questionList[questionIndex].question" :propOpenedInModal="true" :propshowQuestionReportTextarea=true>
      </ReportIssue>
    </b-modal>

    <!-- Modal for detailed answer entry -->
    <b-modal
      v-model="showAnswerModal"
      title="Write Your Answer"
      centered
      hide-footer
      size="xxl"
    >
      <div class="p-2">
        <label class="font-weight-bold mb-2">Answer / Response</label>
        <b-form-textarea
          v-if="userResponses[questionList[questionIndex].qbk_id]"
          v-model="userResponses[questionList[questionIndex].qbk_id].answer"
          placeholder="Type your detailed answer here..."
          rows="12"
          class="form-control"
          style="border-color: #e5252c; height: 100%;"
          @keypress="validateNumericInput($event, questionIndex)"
        ></b-form-textarea>

        <div class="d-flex justify-content-end mt-4">
          <b-button variant="primary" @click="submitTextFromModal">
            Save & Next
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Anti-Cheat / Warning Modal -->
    <b-modal
      v-model="showTabSwitchWarningModal"
      title="Proctored Assessment Warning"
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
    >
      <div class="text-center p-3">
        <i class="fa-solid fa-triangle-exclamation primary-color mb-3" style="font-size: 3rem;"></i>
        <h5 class="font-weight-bold text-dark mb-3">Attention Required</h5>
        <p class="font-size-16 text-muted">{{ tabSwitchWarningMessage }}</p>
        <div class="d-flex justify-content-center mt-3">
          <b-button
            variant="primary"
            class="px-4 font-weight-bold"
            :disabled="tabSwitchCount >= maxTabSwitchesAllowed"
            @click="showTabSwitchWarningModal = false"
          >
            I Understand & Resume
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>
  </div>
</template>
<script>
import QuestionQuizFullPagev1 from "./QuestionQuizFullPagev1.js"

export default {
  name: "QuestionQuizFullFullScreen",
  extends: QuestionQuizFullPagev1
}
</script>
<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat:400,400i,700");
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700");

body {
  font-family: "Open Sans", sans-serif;
  font-size: 18px;
  /* mocking native UI */
  cursor: default !important; /* remove text selection cursor */
  user-select: none; /* remove text selection */
  user-drag: none; /* disbale element dragging */
}
h2.title, .subtitle, h2.title p{
  font-family: "Montserrat", sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: #000;
  line-height: 1.8;
}
.animated {
  transition-duration: 0.3;
}
.que {
  border-bottom: 1px solid #f1f1f1;
  margin-bottom: 10px;
  padding-top: 10px;
}
.questionRow {
  background: white;
  height: 100%;
  border: 1px solid #f1f1f1;
}
.questionBox {
  width: 100%;
  height: calc(100% - 250px) !important; /* use for internal scroll */
  overflow-x: hidden;
  position: relative;
  .quizForm {
    display: block;
    white-space: normal;
    .quizFormContainer {
      height: 100%;
      margin: 15px 18px;
      padding: 10px;
      .field-label {
        text-align: left;
        margin-bottom: 0.5rem;
      }
    }
  }
  .quizCompleted {
    width: 100%;
    padding: 25px;
  }
  .questionContainer {
    white-space: normal;
    margin-top: 18px;
    .optionContainer {
      margin-top: 0px;
      flex-grow: 1;
      padding-left: 5px;
      .option {
        border-radius: 5px;
        margin-bottom: 15px;
        padding: 3px 0px 0px 50px;
        cursor: pointer;
        border: 1px solid #f1f1f1;
        overflow: hidden;
        font-size: 14px;
        min-height: 35px;
        font-weight: 500;
        position: relative;
        display: flex;
        align-items: center;
        color: #000;
        height:auto;
        &.is-selected {
          border-color: var(--iq-primary);
          background-color: white;
        }
        &:hover {
          background-color: rgba(0, 0, 0, 0.1);
        }
      }
    }
    .questionFooter {
      width: 100%;
      align-self: flex-end;
      .pagination {
        margin: 15px 25px;
      }
    }
  }
}
h3.tag {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 5px;
  text-transform: capitalize;
  .duration {
    float: right;
    font-size: 18px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
}
.tags h3 {
  font-size: 18px;
  padding-bottom: 15px;
}
.progress {
  height: 0.5rem;
}
@media screen and (min-width: 769px) {
  .container {
    height: 100%;
    .columns {
      height: 100%;
      .column {
        height: 100%;
      }
    }
  }
  .questionBox {
    height: calc(100% - 180px); /* use for internal scroll */
    .height_scroll {
      height: calc(100% - 180px);
      padding-bottom: 80px;
    }
    .questionContainer {
      display: flex;
      flex-direction: column;
    }
  }
  .que {
    margin-bottom: 0px;
  }
}
.pill_badge_box{
  min-width: 36px;
  max-width: max-content;
  border-radius: 100% !important;
  margin-bottom: 5px;
  height: 36px;
  line-height: 26px !important;
  position: relative;
}
.pill_badge_box_small{
  min-width: 30px;
  max-width: max-content;
  border-radius: 100% !important;
  margin-bottom: 5px;
  height: 30px;
  line-height: 22px !important;
  position: relative;
}
@media screen and (max-width: 768px) {
  .questionFooter {
    button {
      margin: auto;
      margin-bottom: 5px;
    }
  }
}
.next {
  float: right;
}
::-webkit-progress-bar {
  background-color: #f1f1f1;
}
.optionNo {
  background-color: #e5252c;
  color: #fff;
  left: 0px;
  position: absolute;
  width: 40px;
  height: 33px;
  top: 0px;
}
.optionNo span {
  position: absolute;
  right: 0px;
  left: auto;
  top: 0;
  bottom: 0px;
  margin: auto;
  height: 0px;
  font-weight: 600;
  line-height: 0;
  font-size: 14px;
  text-align: center;
  width: 100%;
}
.questionTag {
  white-space: pre-wrap;
  text-transform: unset;
}
/* Question images (image field + images inside question HTML):
   centred, bordered box with a fixed height; the whole image stays visible.
   A grey toolbar at the top of the box holds the zoom button */
::v-deep(.q-img-box) {
  display: block;
  width: fit-content;
  min-width: 200px;
  max-width: 100%;
  margin: 8px auto 16px;
  background-color: #fff;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  box-sizing: border-box;
  overflow: hidden;
  line-height: 0;
  white-space: normal;
}
::v-deep(.q-img-toolbar) {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 4px 8px;
  background-color: #f1f1f1;
  border-bottom: 1px solid #d0d0d0;
  line-height: 1;
}
.que_img,
::v-deep(.questionTag img) {
  display: block;
  height: 274px !important;
  width: auto !important;
  max-width: 100%;
  object-fit: contain;
  margin: 0 auto !important;
  padding: 12px;
  box-sizing: border-box;
}
::v-deep(.q-img-zoom-btn) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background-color: transparent;
  color: #444;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}
::v-deep(.q-img-zoom-btn:hover) {
  background-color: #e2e2e2;
  color: var(--iq-primary);
}
::v-deep(.q-img-zoom-btn:focus-visible) {
  outline: 2px solid var(--iq-primary);
  outline-offset: 1px;
}
@media (max-width: 767px) {
  .que_img,
  ::v-deep(.questionTag img) {
    height: 194px !important;
  }
}
.clock_boxs {
  border: 2px solid;
  border-color: #dcdcdc;
  border-radius: 5px;
  padding: 5px;
  color: #e5252c;
  display: flex;
}
.clock_box1 {
  padding-left: 5px;
  min-width: 35px;
  display: inline-flex;
  text-align: center;
}
.clock_box2 {
  padding-left: 10px;
  min-width: 35px;
  display: inline-flex;
  text-align: center;
}
.colon {
  width: 35px;
  border-left: 2px solid #dcdcdc;
  border-right: 2px solid #dcdcdc;
  padding: 0px 10px;
  text-align: center;
}
.smalltext.title {
  font-size: 14px !important;
  font-weight: 600;
}
.counts {
  margin-bottom: 5px;
  select {
    border: 2px solid #dcdcdc !important;
  }
  .form-control{
    text-align: center;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    width: 80px;
  }
}
@media screen and (max-width: 991px) {
  .hideButton {
    display: none;
  }
  .duration.d-flex {
    width: 100%;
    margin-top: 10px;
    justify-content: flex-end;
  }
}
.full-width-page {
  z-index: 999;
  position: absolute;
  width: 100%;
  display: flex;
  left: 0px;
  top: 0px;
  bottom: 0px;
  padding: 10px !important;
  background-color: #00000047;
  align-items: flex-start;
  height: 100%;
}
.next-btn {
  position: relative;
  top: 3px;
}
.instituteTitle_block {
  width: 100%;
}
.final_result p span{
  width: 180px;
  display: inline-block;
}
.final_result{
  color: #000;
  font-weight: 400;
}
.mark_check{
  position: absolute;
  top: -4px;
  right: 0;
  border: 0px;
  color: yellow;
}
.attachmentCol {
  img {
    height: 32px;
    width: 32px;
    object-fit: contain;
    border: 2px solid aliceblue;
    margin-bottom: 6px;
  }
}
.header-title{
  display: flex;
  align-items: center;
}
.header-title .heading{
  font-weight: 600;
  color: #000;
  font-size: 16px;
  line-height: 11px;
}
.quiz-top-header {
  width: 100%;
  min-height: 64px;
  padding: 8px; /* keeps the title in line with the question bar below */
  border-bottom: 1px solid #d0d0d0; /* divider under the app alias / timer / tools row */
  .clock_boxs {
    font-weight: 700;
    color: #1a1a1a;
    font-size: 18px;
    border: none;
  }
  .colon {
    border: none;
    width: auto;
    padding: 0 4px;
  }
  .timer_drop {
    align-items: center;
    justify-content: center;
  }
  /* no underline or extra margin around the title */
  .que {
    border-bottom: none;
    margin: 0 !important;
    padding: 0;
  }
  /* title, timer and icons share one vertical centre line */
  align-items: center;
  > [class*="col-"] {
    align-self: center;
  }
  #timer,
  .clock_boxs {
    line-height: 1.3;
    padding: 0;
  }
  .header-title-col .heading,
  .header-title-col h3.tag,
  .header-title-col h3.tag span {
    font-size: 22px !important;
    font-weight: 500 !important;
    color: #1a1a1a;
    line-height: 1.3;
    word-break: break-word;
    margin: 0 !important;
    padding: 0;
  }
  @media (max-width: 767px) {
    min-height: 52px;
    padding: 6px 4px;
    .header-title-col .heading,
    .header-title-col h3.tag,
    .header-title-col h3.tag span {
      font-size: 16px !important;
    }
    .clock_boxs {
      font-size: 14px;
      padding: 0;
    }
  }
}
.header-tools {
  gap: 4px;
  .header-tool-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--iq-primary);
    padding: 4px 10px;
    span {
      font-size: 12px;
      margin-top: 2px;
    }
    &:hover {
      opacity: 0.8;
    }
  }
}
.icon-btn {
  color: var(--bs-secondary);
  border: none;
}

.icon-btn:hover {
  color: var(--bs-primary);
}
::v-deep(.optionText p) {
  margin-bottom: 0 !important;
}
.tags.is-marginless{
  width: 100%;
}
.tag.is-rounded span{
  word-wrap: break-word;
}
@media screen and (min-width: 320px) and (max-width: 550px){
  .questionBox{
    height: calc(100% - 380px) !important;
  }
}
@media (min-width: 1200px) {
  .custom-col {
    transition: all 0.5s ease;
  }
 }
@media (min-width: 1600px) {
  .custom-col {
    flex: 0 0 100%;
    max-width: 100%;
    transition: all 0.5s ease;
    padding-right: 0;
  }
  .chatBot-lg {
    position: static;
    right: auto;
    z-index: auto;
  }
}
@media (min-width: 1400px) and (max-width: 1599px) {
  .chatBot-lg{
    position: absolute;
    right: 0;
    z-index: 1;
  }
  .close-chatbot-quiz{
    z-index: 2;
    transition: all 0.5s ease;
  }
}
@media (min-width: 992px) {
  .col-lg-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
  .timer_drop{
    display:flex;
    justify-content: center;
  }
}
.timer_drop{
    display:flex;
  }
  .non-mcq-container{
    position: relative;
  }
  .expandButton{
    position: absolute;
    right: 10px;
    bottom: 10px;
  }
/* Stacked view: question on top, options below, single scroll */
.questionBox .stacked-wrapper {
  height: 100%;
  overflow-y: auto;
}
.stacked-view {
  max-width: 900px;
  margin: 0 auto;
  padding-bottom: 40px;
}
.question-header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f0f0f0;
  margin-top: 12px;
  padding-right: 4px;
  .question-number {
    background-color: #1a1a1a;
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    min-width: 32px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
  }
  .mark-review {
    font-size: 13px;
    color: #000;
    i {
      margin-right: 6px;
    }
  }
}
.stacked-question {
  padding: 18px 4px 4px;
  > .q-img-box {
    margin: 0 auto 10px;
  }
}
.questionBox .questionContainer.stacked-options {
  margin-top: 8px;
  .optionContainer {
    padding-left: 0;
    .option {
      padding: 10px 14px;
      margin-bottom: 14px;
      border: 1px solid #b5b5b5;
      border-radius: 8px;
      min-height: 46px;
      &.is-selected {
        border: 2px solid var(--iq-primary);
        background-color: white;
        .optionNo {
          background-color: var(--iq-primary);
          border-color: var(--iq-primary);
          color: #fff;
        }
      }
    }
  }
}
/* Footer row: Previous | Next */
.footer-nav-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
/* Footer status row: Attempted | Skipped · Question navigator badge · Total Questions */
.footer-status-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}
/* Question navigator: badge with upward popup grid */
.question-nav-anchor {
  position: relative;
}
.question-nav-badge {
  cursor: default;
  &.is-clickable {
    cursor: pointer;
  }
}
.question-nav-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
}
.question-nav-popup {
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 1001;
  width: 420px;
  max-width: calc(100vw - 32px);
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  padding: 16px;
}
.question-nav-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(38px, 1fr));
  gap: 10px;
  max-height: 260px;
  overflow-y: auto;
}
.question-nav-item {
  position: relative;
  height: 38px;
  border: 1.5px dashed #555;
  border-radius: 4px;
  background-color: #fff;
  color: #1a1a1a;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background-color: #f1f1f1;
  }
  &.is-answered {
    border-style: solid;
    border-color: #3366cc;
    background-color: #3366cc;
    color: #fff;
  }
  &.is-skipped {
    border-style: solid;
    border-color: #888;
    background-color: #888;
    color: #fff;
  }
  &.is-current {
    outline: 2px solid #1a1a1a;
    outline-offset: 2px;
  }
  .nav-marked {
    position: absolute;
    top: -6px;
    right: -4px;
    font-size: 12px;
    color: orange;
  }
}
.question-nav-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 14px;
  padding-top: 10px;
  border-top: 1px solid #eee;
  font-size: 12px;
  color: #000;
  .legend-box {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 2px;
    margin-right: 5px;
    vertical-align: middle;
    border: 1.5px dashed #555;
    &.is-current {
      border: 2px solid #1a1a1a;
    }
    &.is-answered {
      border: none;
      background-color: #3366cc;
    }
    &.is-skipped {
      border: none;
      background-color: #888;
    }
  }
}
.stacked-options .optionNo {
  position: static;
  flex: 0 0 26px;
  width: 26px;
  height: 26px;
  margin-right: 14px;
  border: 1.5px solid #1a1a1a;
  border-radius: 50%;
  background-color: transparent;
  color: #1a1a1a;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
